// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"d7e5a5dd","870":"d7e5a5dd"}[chunkId] + ".chunk.css";
};